export const ATTRIBUTE_NAME_ID = {

    /* CHANNEL Section */
    channelSection: {
        aegonPolicy: 'custm_AegonPolNo',
        channel_source: 'Channel',
        landgPolicy: 'Policy Number',
        source: 'source',
        channel: 'channel',
        pensionFund: 'pensionFund'
    },
    /* ANNUITANT SECTION */
    annuitantSection: {
        bankrupt: 'custm_bankruptInd',
        gender: 'gender',
        maritalStatus: 'maritalStatus',
        quotePurpose: 'Quote Reason',
        ukAddress: 'Overseas Customer Allowed',
        emailMarket: 'Email Marketing Allowed'
    },

    /*PLAYGROUND*/
    productOptionsSection: {
        product: 'Product Type',
        paymentAdvance: 'Payment Point',
        paymentFrequency: 'Payment Frequency',
        termYear: 'Policy Year',
        termMonth: 'Policy Month',
        periodOfIncome: 'Guranteed Income control',
        sliderPeriodOfIncome: 'Guaranteed min period',
        incomeIncrease: 'DCJ Escalation Type',
        sliderIncomeIncrease: 'DCJ Escalation Percentage',
        valueProtection: 'Amount Protection Control DCJ',
        sliderIncomePercentageConfig: 'Simplified Spouse Percentage',
        sliderVpConfig: 'Simplified value percentage',
        commencementDateConfig: 'DCJ Future Dated Commencement',
        startDateAgeRangeConfig: 'Customer Age',
        nprBenefit: 'NPR Benefit',
        sliderGuarateedTerm: 'Guarenteed Period'
    },

    /* PLEASE CONFIRM YOUR DETAILS*/
    quotePlayback: {
        womConsent: 'womConsent'
    }
};
